import React, { useCallback } from 'react';
import * as Yup from 'yup';
import { FaPlus } from 'react-icons/fa';

import Radio from '../../../../../../newComponents/Radio';
import { SelectOptionType } from '../../../../../../newComponents/Select';

import { useGridProduct } from '../../../../../../hooks/gridProduct';

import {
  Container,
  Header,
  Options,
  OptionContent,
  WeekDays,
  WeekDaysAvailabilityContainer,
  ShiftsRange,
  ShiftRange,
} from './styles';

export const AvailabilityFormSchema = Yup.object().shape({});

const SCHEDULES: SelectOptionType[] = [];

for (let hours = 1; hours < 24; hours += 1) {
  const formattedHours = String(hours).padStart(2, '0');

  SCHEDULES.push({ label: `${formattedHours}:00`, value: hours });
}

SCHEDULES.push({ label: '00:00', value: 0 });

const Availability: React.FC = () => {
  const {
    details,
    isAwaysAvailability,
    handleAddShift,
    handleRemoveShift,
    handleChangeShift,
    handleChangeProduct,
    handleChangeAvailabilityDays,
  } = useGridProduct();

  const handleChangeAvailability = useCallback(
    (value: boolean) => {
      handleChangeProduct({ isAwaysAvailability: value });
    },
    [handleChangeProduct],
  );

  return (
    <Container>
      <Header>
        <h2>Disponibilidade</h2>
        <p>
          Aqui você define em que momentos os clientes poderão comprar este item
        </p>
      </Header>
      <Options>
        <Radio
          checked={isAwaysAvailability}
          value="false"
          name="availability"
          onChange={() => handleChangeAvailability(true)}
        >
          <OptionContent>
            <strong>Sempre disponível</strong>
            <span>
              O item ficará disponível sempre que o restaurante estiver aberto
            </span>
          </OptionContent>
        </Radio>
        <Radio
          checked={!isAwaysAvailability}
          value="false"
          name="availability"
          onChange={() => handleChangeAvailability(false)}
        >
          <OptionContent>
            <strong>Disponível em dias e horários específicos</strong>
            <span>
              Selecione os períodos em que o item ficará disponível no
              aplicativo
            </span>
          </OptionContent>
        </Radio>
      </Options>
      {!isAwaysAvailability && (
        <WeekDaysAvailabilityContainer>
          <h3>Dias da semana</h3>
          <WeekDays
            selectedDays={details.days}
            onChangeDays={handleChangeAvailabilityDays}
          />
          <ShiftsRange>
            <div className="header">
              <h4>Horários</h4>
              <p onClick={handleAddShift}>
                <FaPlus />
                <span>Adicionar turno</span>
              </p>
            </div>
            <main>
              {details.shifts.map((shift, shiftIndex) => (
                <ShiftRange key={shiftIndex}>
                  <div className="details">
                    <h5>{shiftIndex + 1}º turno</h5>
                    <div className="selects">
                      <select
                        value={shift.startTime}
                        onChange={(event) =>
                          handleChangeShift(
                            'startTime',
                            Number(event.target.value),
                            shiftIndex,
                          )
                        }
                      >
                        {SCHEDULES.map((schedule) => (
                          <option key={schedule.value} value={schedule.value}>
                            {schedule.label}
                          </option>
                        ))}
                      </select>
                      <span>-</span>
                      <select
                        value={shift.endTime}
                        onChange={(event) =>
                          handleChangeShift(
                            'endTime',
                            Number(event.target.value),
                            shiftIndex,
                          )
                        }
                      >
                        {SCHEDULES.map((schedule) => (
                          <option key={schedule.value} value={schedule.value}>
                            {schedule.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleRemoveShift(shiftIndex)}
                  >
                    <span className="material-icons-outlined">delete</span>
                  </button>
                </ShiftRange>
              ))}
            </main>
          </ShiftsRange>
        </WeekDaysAvailabilityContainer>
      )}
    </Container>
  );
};

export default Availability;
